export default function Footer() {
  return (
    <footer className="mt-20 py-6 text-center border-t dark:border-gray-700">
      <p className="text-sm text-gray-500 dark:text-gray-400">
        © 2026 JobTracker • Built by Garima Singh. All rights reserved.
      </p>
    </footer>
  );
}